module.exports = __webpack_public_path__ + "static/media/mondadori-logo.e346eab5.svg";